// Simple navigation history service with filter memory
class NavigationService {
  static MAX_HISTORY = 5; // Increased to handle more navigation

  // Save current page to navigation history
  static saveCurrentPage(pathname, filters = null) {
    const navHistory = JSON.parse(localStorage.getItem("navHistory") || "[]");
    
    // Don't add duplicate consecutive entries
    if (navHistory.length > 0 && navHistory[navHistory.length - 1].path === pathname) {
      // Update filters for current page if provided
      if (filters !== null) {
        navHistory[navHistory.length - 1].filters = filters;
        localStorage.setItem("navHistory", JSON.stringify(navHistory));
      }
      return;
    }

    const pageEntry = {
      path: pathname,
      timestamp: Date.now(),
      filters: filters
    };

    navHistory.push(pageEntry);

    // Keep only last MAX_HISTORY entries
    if (navHistory.length > this.MAX_HISTORY) {
      navHistory.shift();
    }

    localStorage.setItem("navHistory", JSON.stringify(navHistory));
  }

  // Get previous page from navigation history
  static getPreviousPage(currentPath) {
    const navHistory = JSON.parse(localStorage.getItem("navHistory") || "[]");
    
    // Find current page index
    let currentIndex = -1;
    for (let i = navHistory.length - 1; i >= 0; i--) {
      if (navHistory[i].path === currentPath) {
        currentIndex = i;
        break;
      }
    }

    // If current page found and there's a previous page
    if (currentIndex > 0) {
      return navHistory[currentIndex - 1].path;
    }

    // If current page not found but there are pages in history
    if (currentIndex === -1 && navHistory.length > 0) {
      return navHistory[navHistory.length - 1].path;
    }

    return null;
  }

  // Get filters for current page from history
  static getFiltersForPage(pathname) {
    const navHistory = JSON.parse(localStorage.getItem("navHistory") || "[]");
    const pageEntry = navHistory.find(entry => entry.path === pathname);
    return pageEntry?.filters || null;
  }

  // Save filters for current page
  static saveFiltersForCurrentPage(pathname, filters) {
    const navHistory = JSON.parse(localStorage.getItem("navHistory") || "[]");
    const pageIndex = navHistory.findIndex(entry => entry.path === pathname);
    
    if (pageIndex !== -1) {
      navHistory[pageIndex].filters = filters;
      localStorage.setItem("navHistory", JSON.stringify(navHistory));
    } else {
      // If page not in history, add it with filters
      this.saveCurrentPage(pathname, filters);
    }
  }

  // Clear navigation history
  static clearHistory() {
    localStorage.removeItem("navHistory");
  }

  // Get current navigation history (for debugging)
  static getHistory() {
    return JSON.parse(localStorage.getItem("navHistory") || "[]");
  }
}

export default NavigationService;